// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HvBpIjU4WGlVjZgdc81n {
    background-color: #F8FAFF;

    width: 100%;
    min-height: calc(100vh - 75px);

    display: flex;
    justify-content: center;
}

.KqUMf9ANLB_H6JOWdepn {
    margin-top: 48px;

    background-color: white;
    border-radius: 5px;
    box-shadow: 0 0 15px ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray-light"]};
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray-light"]};

    padding: 24px;
    width: 550px;
    height: max-content;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.mgkKhSEUx900wxxIQsEm {
    margin: auto;
    background-color: #FAEDED;

    width: 80px;
    height: 80px;
    border-radius: 80px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.xB58f1strluL_Cp1c_Dk {
    color: #E30101;
    font-size: 30px !important;
}

.zMdeHpgBApDDisVXyUOA {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
}

.lk23T38JLZv2r2LT6iws {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    letter-spacing: 0.005em;
    color: rgba(0, 0, 0, 0.55);
    margin-top: 0;
}

.EAMQOVs7IuyMIusUOXgO {
    width: 100%;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
    .KqUMf9ANLB_H6JOWdepn {
        min-width: unset;
        width: 90%;
    }

    .HvBpIjU4WGlVjZgdc81n {
        padding-top: 75px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/ConfirmationError/ConfirmationError.module.css"],"names":[],"mappings":"AAMA;IACI,yBAAyB;;IAEzB,WAAW;IACX,8BAA8B;;IAE9B,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;;IAEhB,uBAAuB;IACvB,kBAAkB;IAClB,iEAAqC;IACrC,8DAAkC;;IAElC,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;;IAEtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;;IAEzB,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-gray-light from colors;\n\n.background {\n    background-color: #F8FAFF;\n\n    width: 100%;\n    min-height: calc(100vh - 75px);\n\n    display: flex;\n    justify-content: center;\n}\n\n.modal {\n    margin-top: 48px;\n\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0 0 15px color-gray-light;\n    border: 1px solid color-gray-light;\n\n    padding: 24px;\n    width: 550px;\n    height: max-content;\n    box-sizing: border-box;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.illustration {\n    margin: auto;\n    background-color: #FAEDED;\n\n    width: 80px;\n    height: 80px;\n    border-radius: 80px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.icon {\n    color: #E30101;\n    font-size: 30px !important;\n}\n\n.title {\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 21px;\n    text-align: center;\n}\n\n.description {\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 150%;\n    text-align: center;\n    letter-spacing: 0.005em;\n    color: rgba(0, 0, 0, 0.55);\n    margin-top: 0;\n}\n\n.button {\n    width: 100%;\n}\n\n@media screen and (max-width: tablet) {\n    .modal {\n        min-width: unset;\n        width: 90%;\n    }\n\n    .background {\n        padding-top: 75px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray-light"]}`,
	"background": `HvBpIjU4WGlVjZgdc81n`,
	"modal": `KqUMf9ANLB_H6JOWdepn`,
	"illustration": `mgkKhSEUx900wxxIQsEm`,
	"icon": `xB58f1strluL_Cp1c_Dk`,
	"title": `zMdeHpgBApDDisVXyUOA`,
	"description": `lk23T38JLZv2r2LT6iws`,
	"button": `EAMQOVs7IuyMIusUOXgO`
};
export default ___CSS_LOADER_EXPORT___;
